<template>
  <div class="faults">
            <Breadcrumb :home="home" :model="items" />
    <div class="filters">

      <span class="p-input-icon-left">
        <i class="pi pi-filter" />
        <InputText type="text" v-model="filterText" placeholder="Filter" />
      </span>
    </div>
    <div class="fault_list">
      <div class="fault" v-for="f in filteredFaults" :key="f.id">
        <div class="p-d-flex p-jc-center">
          <div class="p-px-3">
            <h3 class="p-m-2">{{ f.admin }}</h3>
          </div>

          <div class="techstatus p-px-3">
            <h3 class="p-m-2">{{ f.techstatus }}</h3>
          </div>
        </div>

        <div class="desc">
          <h3 class="p-text-uppercase p-m-0">{{ f.desc }}</h3>
        </div>


        <div class="created item">
          <div>Date Reported:</div>
          <b>{{ formatDate(f.created) }}</b>
        </div>

        <div class="user item">
          <div>Operator:</div>
          <b v-if="f.user"
            >{{ f.user.rank }} {{ f.user.lastname }}, {{ f.user.firstname }}
          </b>
          <b v-else>Not assigned</b>
        </div>


        <div class="repairstatus item">
          <div>Status of Repair:</div>
          <b>{{ f.repairstatus || "..." }}</b>
        </div>

        <div class="selector p-mb-3">
          <router-link
            tag="div"
            class="edit p-shadow-8"
            :to="'/mech/fault/' + f.id"
            >Edit Fault</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fb_db, fs, fb_users, fb_auth } from "../firebase";
import { format } from "date-fns";
import Breadcrumb from "primevue/breadcrumb";


export default {
  name: "NewFaults",
  components: {
Breadcrumb,
  },
  data() {
    return {
                  home: { label: "My Workbench", to: "/faultsworkbench" },
                  items: [{ label: "My Assigned Work"}],
      faults: [],
      confirmRemoveDialog: false,
      filterText: "",
      selectedStatus: "Assigned",

      repairStatusList: [
        "All",
        "In Process",
        "Parts Required",
        "Additonal Time",
        "Repairs Complete",
        "Could Not Validate",
      ],
    };
  },
  async mounted() {
    await this.getMyFaults();
  },
  methods: {
    async getMyFaults() {
      this.loading = true;
      const docs = await fb_db
        .collection("faults")
        .where("mechanic", "==", fb_users.doc(fb_auth.currentUser.uid))
        .get()
        .then((docs) => {
          this.faults = [];
          docs.forEach(async (doc) => {
            let item = doc.data();
            item.id = doc.id;
            let user = await item.user.get();
            item.user = user.data();
            if (item.mechanic) {
              console.debug("loading mech");
              let mech = await item.mechanic.get();
              item.mechanic = mech.data();
            }
            this.faults.push(item);
          });
          this.loading = false;
        })
        .catch((error) => {
          console.error("error getting faults: ", error);
        });
    },

    formatDate(date) {
      let dt = date.toDate();
      return format(dt, "HH:mm MM/DD/YYYY");
    },
  },
  computed: {
    filteredFaults() {
      return this.faults.filter((f) => {
        if (this.selectedStatus == "All") {
          return (
            f.admin.toLowerCase().indexOf(this.filterText.toLowerCase()) > -1
          );
        } else if (this.selectedStatus == "Assigned") {
          return (
            f.status == "Assigned" &&
            f.admin.toLowerCase().indexOf(this.filterText.toLowerCase()) > -1
          );
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/theme.scss";

.faults {
  .fault_list {
    .fault {
      width: 300px;

      background: #efefef;
      border-radius: 10px;
      margin: 10px;
      float: left;

      div {
        margin: 0px 5px;
        padding: 5px 15px;
        border-radius: 5px;
        // color: $white;
      }

      .edit {
        background: $accent;
        // color: $text;
        cursor: pointer;
      }

      .delete {
        background: $primary;
        // color: $white;
        cursor: pointer;
      }

      .item {
        padding: 5px;
        text-align: left;

        b {
          margin-left: 25px;
        }

        div {
          font-size: 14px;
        }
      }

      .admin {
      }

      .techstatus {
        color: red;
        font-size: 25px;
      }

      .desc {
        color: #000000;
      }

      .verify {
      }

      .repairstatus {
      }

      .user {
        color: black;
      }

      .created {
      }

      .mechanic {
      }

      .assigned {
        color: #FFCC5C;
      }
    }
  }
}
</style>